import React from "react";
import { Loader2 } from "lucide-react";

export const BonkerLogo: React.FC<{ src?: string | null; className?: string }> = ({
  src,
  className = "",
}) => {
  if (src) {
    return <img src={src} alt="Bonker" className={`w-auto ${className || "h-8"}`} data-testid="brand-logo-img" />;
  }
  return (
    <span
      data-testid="brand-logo-text"
      className={`font-display font-black tracking-tighter text-2xl leading-none select-none ${className}`}
    >
      BONK<span className="text-primary">ER</span>
      <span className="text-secondary">.</span>
    </span>
  );
};

export const FullScreenLoader: React.FC = () => (
  <div className="min-h-screen bg-background flex items-center justify-center" data-testid="app-loader">
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
  </div>
);
